// extracted by css-extract-rspack-plugin
export default {"skeletonItem":"ListParts-module__skeletonItem__Hh4jr","itemTitle":"ListParts-module__itemTitle__gt5VX","itemTitleInner":"ListParts-module__itemTitleInner__hYK4d"};